module.exports = __webpack_public_path__ + "img/cameraBackground.e46c1e32.png";